// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Bk03","selected":"Chip_selected__2QtQ-"};